import { BaseAPIModel } from '@weezevent/weezjs-core';
import { ArgumentError } from '../utils/errors';

/**
 * Subscription.
 *
 * @param {Object} params - Object parameter
 * @constructor
 */
export default class Subscription extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    setInfo(data) {
        switch (this.type) {
            case 'digitick':
                this.login = data.login;
                this.password = data.password;
                this.wsdl = data.wsdl;
                break;
            case 'fever':
                this.api_key = data.api_key;
                this.user_id = data.user_id;
                break;
            case 'fnac':
                this.login = data.login;
                this.password = data.password;
                break;
            case 'universe':
                this.auth_code = data.authCode;
                break;
            case 'lennd':
                this.access_token = data.accessToken;
                break;
            case 'secutix':
                this.login = data.login;
                this.password = data.password;
                this.url = data.url;
                break;
            case 'seetickets_de':
                this.merchant_id = data.merchant_id;
                this.refresh_token = data.refresh_token;
                break;
            case 'seetickets_es':
                this.promoter_id = data.promoter_id;
                this.promoter_name = data.promoter_name;
                break;
            case 'regiondo':
                this.public_key = data.public_key;
                this.private_key = data.private_key;
                break;
            case 'ticketnet':
                this.login = data.login;
                this.password = data.password;
                this.account_type = data.account_type;
                break;
            case 'playpass':
                this.login = data.login;
                this.password = data.password;
                this.tenant = data.tenant;
                this.getin_url = data.getin_url;
                break;
            case 'vivenu':
                this.access_token = data.access_token;
                break;
            case 'ticketmastersport':
                this.api_key = data.api_key;
                break;
            default:
                throw new Error(`[Subscription] Subscription type ${this.type} is unknown. Cannot be saved`);
        }
    }

    static listUrl({ organizationId }) {
        if (!organizationId) {
            throw new ArgumentError('[Model][Subscription] organizationId is mandatory');
        }
        return `/ticket-imports/organizations/${organizationId}/subscriptions`;
    }

    static getItemUrl(params) {
        if (!params.id) {
            throw new ArgumentError(`[Model][${this.constructor.name}] id is mandatory`);
        }

        if (!params.get_filters) {
            return `${this.getListUrl(params)}/${params.id}`;
        }

        return `${this.getListUrl(params)}/${params.id}/get_tickets_filter`;
    }

    static get_tickets_filter({ organizationId, subscriptionId }) {
        if (!organizationId || !subscriptionId) {
            throw new ArgumentError(`[Model][Subscription][get_tickets_filter] organizationId and subscriptionId are mandatory`);
        }

        let url = `/ticket-imports/organizations/${organizationId}/subscriptions/${subscriptionId}/get_tickets_filter`;
        return BaseAPIModel.fetcher.get(url);
    }

    static push_tickets({ organizationId, subscriptionId }) {
        if (!organizationId || !subscriptionId) {
            throw new ArgumentError(`[Model][Subscription][push_tickets] organizationId and subscriptionId are mandatory`);
        }

        let url = `/ticket-imports/organizations/${organizationId}/subscriptions/${subscriptionId}/push_tickets`;
        return BaseAPIModel.fetcher.post(url);
    }

    static repushScans({ organizationId, subscriptionId, linkIds }) {
        if (!organizationId || !subscriptionId) {
            throw new ArgumentError(`[Model][Subscription][repushScans] organizationId and subscriptionId are mandatory`);
        }

        const data = linkIds ? { link_ids: linkIds } : null;
        return BaseAPIModel.fetcher.post(`/ticket-imports/organizations/${organizationId}/subscriptions/${subscriptionId}/push_scans`, { data });
    }

    is_push() {
        return this.type === 'hook';
    }
}
